var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f5fbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244ea3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9c072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfa557"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.85714286 2.66666667-.53874803.15779564.15779565-.53874802-.15779565-.53874803.53874803.15779564.53874802-.15779564-.15779564.53874803.15779564.53874802zm2.28571428 0-.53874804.15779564.15779566-.53874802-.15779566-.53874803.53874804.15779564.53874804-.15779564-.15779566.53874803.15779566.53874802zm2.28571426.76190476-.538748.15779564.1577956-.53874802-.1577956-.53874803.538748.15779565.5387481-.15779565-.1577957.53874803.1577957.53874802zm1.5238096 1.52380952-.5387481.15779564.1577957-.53874802-.1577957-.53874802.5387481.15779564.538748-.15779564-.1577957.53874802.1577957.53874802zm-9.90476195 0-.53874803.15779564.15779565-.53874802-.15779565-.53874802.53874803.15779564.53874802-.15779564-.15779564.53874802.15779564.53874802zm1.52380952-1.52380952-.53874802.15779564.15779564-.53874802-.15779564-.53874803.53874802.15779565.53874802-.15779565-.15779564.53874803.15779564.53874802z",
    fill: "url(#a)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.85714286 7.61904762-.76190476-.38095238-.76190477-1.52380953h.76190477l.76190476-.76190476.38095238-.76190476.76190476-.38095238.38095238.38095238.76190476.38095238v.38095238l.38095238.38095238 1.14285718.76190477-.3809524 1.14285714-1.14285716 1.14285714-.38095238-.76190476-1.14285714.76190476v.76190476l-.38095238-.38095238z",
    fill: "url(#d)",
    mask: "url(#e)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXk);
export default __webpack_public_path__ + "static/media/XK.a246fa0656fd79702d672805d4e6bebf.svg";
export { ForwardRef as ReactComponent };